<template>
  <div class="p-12">
    <div class="max-w-5xl mx-auto">
      <div class="space-y-16">
        <div class="flex items-center justify-between">
          <h4 class="text-indigo-500 capitalize">Contact Requests</h4>
        </div>

        <BaseAdvancedList searchable :loading="loading" :entities="contactRequests" :meta="meta">
          <template #header>
            <ContactHeaderLine />
          </template>

          <template #default="listProps">
            <ContactRequestLine
              :contact-request="listProps.entity"
              :focus="lastEditedContactRequestId === listProps.entity.id"
              @editing="setLastEditedContactRequestId"
              @edited="fetchData"
            />
          </template>
        </BaseAdvancedList>
      </div>
    </div>
  </div>
</template>

<script>
import ContactHeaderLine from '@/components/ContactRequests/ContactHeaderLine.vue';
import ContactRequestLine from '@/components/ContactRequests/ContactRequestLine.vue';

export default {
  components: {
    ContactHeaderLine,
    ContactRequestLine,
  },
  data: () => ({
    loading: false,
    contactRequestIdToEdit: null,
    lastEditedContactRequestId: null,
  }),
  computed: {
    meta() {
      return this.$store.state.ui.contactRequests.meta || null;
    },
    contactRequests() {
      return this.$store.getters['ui/contactRequests/items'];
    },
  },
  watch: {
    $route: 'fetchData',
  },
  created() {
    this.fetchData();
  },
  destroyed() {
    this.$store.commit('ui/contactRequests/setIds', []);
    this.$store.commit('ui/contactRequests/setMeta', null);
    this.$store.commit('ui/contactRequests/setLinks', null);
  },
  methods: {
    async fetchData() {
      const { query } = this.$route;
      this.loading = true;
      try {
        await this.$store.dispatch('ui/contactRequests/load', {
          query: {
            ...query,
            include: 'account.logo,project,pipelineStage',
          },
        });
      } catch (error) {
        //
      }
      this.loading = false;
    },
    setLastEditedContactRequestId(contactRequestId) {
      this.lastEditedContactRequestId = contactRequestId;
    },
  },
};
</script>
